import { render, staticRenderFns } from "./UserReviewRequestIcon.vue?vue&type=template&id=4a2ee144"
import script from "./UserReviewRequestIcon.vue?vue&type=script&lang=ts"
export * from "./UserReviewRequestIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports